/**
 * Extracts thinking content from a message that contains <thinking> tags
 * and returns both clean content and extracted thinking
 */
export function extractThinkingContent(content: string): {
  cleanContent: string;
  thinkingContent: string;
  extractedThinking: string;
} {
  // Initialize empty thinking content
  let thinkingContent = '';
  
  // Extract all thinking tags and their content - need to handle line breaks
  // Since we can't use the /s flag in this environment, we'll use a workaround
  const thinkingRegex = /<thinking>([^]*?)<\/thinking>/g;
  let match;
  let cleanContent = content;
  
  // Find all thinking tags and build up the thinking content
  while ((match = thinkingRegex.exec(content)) !== null) {
    const thinkingPart = match[1];
    if (thinkingPart && thinkingPart.trim()) {
      thinkingContent += thinkingPart + '\n';
    }
  }
  
  // Remove thinking tags from the clean content
  cleanContent = cleanContent.replace(thinkingRegex, '');
  // Only remove extra whitespace at the start and end, preserving whitespace in the middle
  // that might be needed for markdown formatting
  cleanContent = cleanContent.trim();

  /* Add a log to help debug
  console.log(
    'Extracted thinking tags:',
    content.match(/<thinking>([^]*?)<\/thinking>/g)?.length || 0,
    'Thinking content length:',
    thinkingContent.length
  );*/

  return {
    cleanContent,
    thinkingContent: thinkingContent.trim(),
    extractedThinking: thinkingContent.trim()
  };
}